const styles = `:host > div {
  /* Using !important here is necessary. The most common reason is for MUI to add
    * { box-sizing: content-box; }
    and that will override any
    :host { box-sizing: border-box }
    in our code
  */
  box-sizing: border-box !important;
  display: inline-flex;
}
:host > div .action::part(control) {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}
:host > div [slot=trigger] {
  --goto-button-min-width: 40px;
  --goto-button-padding: 0;
  border-left: 1px solid transparent;
}
:host > div [slot=trigger]::part(control) {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}
:host > div [slot=start] {
  align-items: center;
  display: inline-flex;
}
:host > div [slot=start] ::slotted(chameleon-svg) {
  --goto-icon-size: 18px;
  margin: 0 7px 0px -5px;
}
:host > div chameleon-popover::part(popover) {
  margin-top: -2px;
}

:host([variant=secondary]) [slot=trigger] {
  border-left: none;
  margin-left: -1px;
}
:host([variant=secondary]) [slot=trigger]::part(control) {
  border-left-color: transparent;
}

:host([size=small]) [slot=trigger] {
  --goto-button-min-width: 28px;
}

:host([size=large]) [slot=trigger] {
  --goto-button-min-width: 42px;
}

:host([size=xlarge]) [slot=trigger] {
  --goto-button-min-width: 48px;
}`; export default styles;